<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card v-if="page" :loading="loading">
                  <v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`" class="h3">{{ page.title }}</v-card-title>
                  <v-card-text>
                    <v-row class="align-center" v-if="page">
                      <v-col cols="12" class="mx-auto">
                        <v-img v-if="page.image" width="100%" :src="page.image" />
                      </v-col>
                      <v-col cols="12" class="px-6">
                        <div :class="`${arabic ? 'arFont ql-page' : 'enFont'}`" v-html="page.body"></div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :href="page.contact_url" color="blue" text :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["click_here_to_contact_us"] }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      page: null
    }
  },
  methods: {
    async showPage() {
      this.loading = true
      this.page = await this.$store.dispatch('getResource', { resource: `/service-pages/${this.$route.params.page}` })
      this.loading = false
    }
  },
  watch: {
    '$route.params.page': {
      async handler(value) {
        await this.showPage()
      }
    }
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
  },
  async mounted() {
    await this.showPage()
  },
}
</script>

<style>
.ql-page h1,
.ql-page h2,
.ql-page h3,
.ql-page h4,
.ql-page h5,
.ql-page h6,
.ql-page p,
.ql-page span
{
  line-height: 1.5;    
}

.ql-page img {
  width:100%;
}
</style>